export class PressureRange {

  constructor(
    public start: number,
    public end: number,
    public threshold: number,
  ) {
  }

  public clone(): PressureRange {
    return new PressureRange(this.start, this.end, this.threshold);
  }

  public copy(other: PressureRange): this {
    this.start = other.start;
    this.end = other.end;
    this.threshold = other.threshold;
    return this;
  }

  public equals(other: PressureRange): boolean {
    return this.start === other.start
      && this.end === other.end
      && this.threshold === other.threshold;
  }

}
